module.exports = __webpack_public_path__ + "static/media/promo-image-apoteka-mobile.61793578.png";